import {AssetFinanceTier3} from '../admin-service.domain';

export type AssetTier3Value = AssetFinanceTier3 | null;
